import { singleItemDefaultConfig } from '../singleitemdisplay/SingleItemDisplay'

export default {
    ...singleItemDefaultConfig,
    header: 'Prize',
}